import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  ID_CATEGORY_BED,
  ID_CATEGORY_MATTRESS,
  ID_CATEGORY_PILLOW,
  ID_CATEGORY_SOFA,
  PRODUCT_PROPS_COVER,
  PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER,
  PROPERTY_TYPE,
  PROP_BED_PREMIUM,
  PROP_BED_SIMILI,
  PROP_SOFA_ROSSY_LUXE_PREMIUM,
  PROP_SOFA_ROSSY_LUXE_SIMILI,
} from "../../common/constant";
import { useQuantity } from "../../hooks/useQuantity";
import { addProductToCart } from "../../redux/reducers/slice/cart";
import {
  addCompareProduct,
  removeCompareProduct,
  selectCompareProducts,
  selectIsCheckGrandOpeningPromotion,
} from "../../redux/reducers/slice/common";
import {
  checkGrandOpeningPromotion,
  checkInCompareList,
  checkNewProductFeature,
  checkNewProductFeatureByCoverType,
  checkNewProductFeatureHaveCover,
  checkProductHaveCover,
  checkProductHaveType,
  checkRossyLuxe,
  getMinKdeProIdFromFeatures,
  getNumberFromFeature,
  getSlugByLanguage,
} from "../../shared/helpers";
import NotificationAddToCartSuccess from "../notification";
import ProductItemComponent from "../productItem";
import { CABINET, DESK, DESK_OPTIONS } from "../productItem/deskSelect";
import WishButton from "../wishButton";
import "./style.scss";
// import queryString from "query-string";

const FilterProductItem = (props: any) => {
  const { slug, product, feature, parentIndex, index } = props;
  const compareProducts = useSelector(selectCompareProducts);
  const isCheckGrandOpeningPromotion = useSelector(
    selectIsCheckGrandOpeningPromotion
  );
  const [currentFeature, setCurrentFeature] = React.useState(
    feature.length ? feature[0] : feature
  );
  const [checkDesk, setCheckDesk] = React.useState(false);
  const [minKdeProId, setMinKdeProId] = React.useState(-1);
  const [typeCover, setTypeCover] = React.useState<any>(
    checkRossyLuxe(
      feature && feature.length ? feature[0].cat_id_v2?.toString() : ""
    )
      ? PROP_SOFA_ROSSY_LUXE_PREMIUM
      : PROP_BED_PREMIUM
  );
  const [quantity, decreaseQuantity, increaseQuantity, resetQuantity] =
    useQuantity(1);
  const [foam, setFoam] = React.useState(1);
  const [listFeatures, setListFeatures] = React.useState<any>(feature);
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const minKdeId = getMinKdeProIdFromFeatures(feature);

    if (minKdeId !== -1) {
      setMinKdeProId(minKdeId);
    }
  }, []);

  React.useEffect(() => {
    if (minKdeProId !== -1) {
      if (listFeatures) {
        if (listFeatures.length && listFeatures[0].value) {
          const _listFeatures = getListFeatures(
            feature,
            checkRossyLuxe(
              feature && feature.length ? feature[0].cat_id_v2?.toString() : ""
            )
              ? PROP_SOFA_ROSSY_LUXE_PREMIUM
              : PROP_BED_PREMIUM
          );
          setListFeatures(_listFeatures);
          setCurrentFeature(_listFeatures.length ? _listFeatures[0] : feature);
        } else {
          setCurrentFeature(listFeatures.length ? listFeatures[0] : feature);
        }
      }
    }
  }, [product, minKdeProId]);

  React.useEffect(() => {
    if (minKdeProId !== -1) {
      const _listFeatures = getListFeatures(feature, typeCover);

      setListFeatures(_listFeatures);

      const _prevFeature = currentFeature;
      const numberSizePrevFeature = getNumberFromFeature(_prevFeature.value);
      const _currentFeature = _listFeatures.find((f: any) =>
        f.value.includes(numberSizePrevFeature)
      );

      setCurrentFeature(
        _currentFeature
          ? _currentFeature
          : _listFeatures.length
            ? _listFeatures[0]
            : feature
      );
    }
  }, [checkDesk]);

  const hasPillowSpec = currentFeature && currentFeature.pillowSpec;
  const isPillowFeature = currentFeature?.category_id === ID_CATEGORY_PILLOW;
  const isCustomPillowGroupBySize =
    isPillowFeature &&
    (currentFeature?.is_custom_pillow_group_by_size || Array.isArray(feature));
  const isNeedDropdownFeatures =
    product.is_need_dropdown_features &&
    (!isPillowFeature || isCustomPillowGroupBySize);

  const getDataAddToCart = () => ({
    _id:
      (currentFeature?.product_props?.length && currentFeature?.cat_id_v2) ||
      product.cat_id,
    category_name: product.category_name,
    slug: getEntityForSlug() ? getEntityForSlug().slug : "",
    slug_en: getEntityForSlug() ? getEntityForSlug().slug_en : "",
    cat_id_v2: currentFeature.cat_id_v2.toString(),
    code: currentFeature.value,
    parent_pro_id: currentFeature.parent_pro_id,
    disable_buy_button: currentFeature.disable_buy_button,
    disable_buy_button_message: currentFeature.disable_buy_button_message,
    feature: {
      currency: "VNĐ",
      discount_percent: currentFeature.discount_percent,
      feature_id: currentFeature.feature_id,
      price: currentFeature.price,
      price_promotion: currentFeature.price_promotion,
      price_save: currentFeature.price_save,
      product_cat_id: product.cat_id,
      spec: currentFeature.label,
    },
    product_property: currentFeature.is_have_foam
      ? {
          [PROPERTY_TYPE.foam]: {
            code: PROPERTY_TYPE.foam,
            image: null,
            is_use: false,
            label: product.specs.find(
              (spec: any) => spec.kde_pro_spec_id === foam
            )?.extra_name,
            position: 3,
            title: "Tỷ trọng (density) foam",
            value: foam,
          },
        }
      : hasPillowSpec
        ? {
            [PROPERTY_TYPE.image]: {
              code: PROPERTY_TYPE.image,
              image:
                currentFeature.pillowSpec.img_details &&
                currentFeature.pillowSpec.img_details.length
                  ? currentFeature.pillowSpec.img_details[0].path
                  : product.img,
              is_use: false,
              label: currentFeature.pillowSpec.name,
              position: 3,
              title: "Hoa văn",
              value: currentFeature.pillowSpec.kde_pro_spec_id,
            },
          }
        : null,
    // gift_quantity: 1,
    img: currentFeature?.img?.path,
    name: currentFeature?.name,
    // services: prod.services,
    wish: false,
  });

  const handleAddToCart = async () => {
    const _data = getDataAddToCart();
    const addToCartResponse = await dispatch(
      addProductToCart(_data, true, quantity)
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: currentFeature?.name,
        productFeature: currentFeature.label,
      });

      let parentNode = document.getElementsByClassName("filter-product-list")[
        parentIndex
      ];

      if (!parentNode) return false;

      return { parentNode, index };
    }
    return false;
  };

  const handleChangeType = (value: any) => {
    setCheckDesk(value);
  };

  const handleOnChangeCover = (value: any) => {
    const _listFeatures = getListFeatures(feature, value);

    setTypeCover(value);
    setListFeatures(_listFeatures);

    const _prevFeature = currentFeature;
    const numberSizePrevFeature = getNumberFromFeature(_prevFeature.value);
    const _currentFeature = _listFeatures.find((f: any) =>
      f.value.includes(numberSizePrevFeature)
    );

    setCurrentFeature(
      _currentFeature
        ? _currentFeature
        : _listFeatures.length
          ? _listFeatures[0]
          : feature
    );
  };

  const handleOnChange = (value: any) => {
    const f = _.find(listFeatures, { value: value });

    setCurrentFeature(f);
  };

  const handleChangeFoam = (value: number) => {
    setFoam(value);
  };

  const getDeskEndsWith = () => {
    const defaultEndsWith = "B";
    const productProps = currentFeature?.product_props;

    if (!productProps || !productProps.length) {
      return defaultEndsWith;
    }

    const typeAttribute = productProps.find(
      (item: any) => item.code === PROPERTY_TYPE.type
    );

    if (!typeAttribute) {
      return defaultEndsWith;
    }

    return typeAttribute?.ends_with || defaultEndsWith;
  };

  const getListFeatures = (features: any[], coverType: string) => {
    let results = [];
    if (features && features.length && features[0].value) {
      if (
        checkProductHaveCover(
          features[0].value,
          checkRossyLuxe(
            feature && feature.length ? feature[0].cat_id_v2?.toString() : ""
          ),
          checkNewProductFeatureHaveCover(features[0])
        )
      ) {
        results = features.filter(
          (f: any) =>
            (!checkNewProductFeatureHaveCover(features[0])
              ? f.value.endsWith(coverType)
              : checkNewProductFeatureByCoverType(f, coverType)) &&
            (checkDesk
              ? !checkNewProductFeature(features[0])
                ? f.kde_pro_id > minKdeProId
                : f.value.endsWith(getDeskEndsWith())
              : !checkNewProductFeature(features[0])
                ? f.kde_pro_id === minKdeProId
                : !f.value.endsWith(getDeskEndsWith()))
        );

        if (!results.length) {
          results = features.filter(
            (f: any) =>
              f.value.endsWith(
                checkRossyLuxe(
                  feature && feature.length
                    ? feature[0].cat_id_v2?.toString()
                    : ""
                )
                  ? coverType === PROP_SOFA_ROSSY_LUXE_PREMIUM
                    ? PROP_SOFA_ROSSY_LUXE_SIMILI
                    : PROP_SOFA_ROSSY_LUXE_PREMIUM
                  : coverType === PROP_BED_PREMIUM
                    ? PROP_BED_SIMILI
                    : PROP_BED_PREMIUM
              ) &&
              (checkDesk
                ? !checkNewProductFeature(features[0])
                  ? f.kde_pro_id > minKdeProId
                  : f.value.endsWith(getDeskEndsWith())
                : !checkNewProductFeature(features[0])
                  ? f.kde_pro_id === minKdeProId
                  : !f.value.endsWith(getDeskEndsWith()))
          );
          setTypeCover(
            checkRossyLuxe(
              feature && feature.length ? feature[0].cat_id_v2?.toString() : ""
            )
              ? coverType === PROP_SOFA_ROSSY_LUXE_PREMIUM
                ? PROP_SOFA_ROSSY_LUXE_SIMILI
                : PROP_SOFA_ROSSY_LUXE_PREMIUM
              : coverType === PROP_BED_PREMIUM
                ? PROP_BED_SIMILI
                : PROP_BED_PREMIUM
          );
        }
      } else {
        results = features.filter((f: any) =>
          checkDesk
            ? !checkNewProductFeature(features[0])
              ? f.kde_pro_id > minKdeProId
              : f.value.endsWith(getDeskEndsWith())
            : !checkNewProductFeature(features[0])
              ? f.kde_pro_id === minKdeProId
              : !f.value.endsWith(getDeskEndsWith())
        );
      }
    }

    return results;
  };

  const getName = () => {
    let name = currentFeature.name || "";

    if (
      currentFeature.category_id === ID_CATEGORY_BED ||
      currentFeature.category_id === ID_CATEGORY_SOFA
    ) {
      name =
        feature.filter((f: any) =>
          !checkNewProductFeature(f)
            ? f.kde_pro_id === minKdeProId
            : !f.value.endsWith(getDeskEndsWith())
        )[0]?.name || "";
    }

    return name;
  };

  const getImage = () => {
    let src = currentFeature?.img ? currentFeature.img._id : "";

    if (
      currentFeature.category_id === ID_CATEGORY_BED ||
      currentFeature.category_id === ID_CATEGORY_SOFA
    ) {
      src = feature.filter((f: any) =>
        !checkNewProductFeature(f)
          ? f.kde_pro_id === minKdeProId
          : !f.value.endsWith(getDeskEndsWith())
      )[0]?.img?._id;
    }

    return src;
  };

  const getPropertiesCompare = () => {
    const checkRossyLuxeValue = checkRossyLuxe(
      feature && feature.length ? feature[0].cat_id_v2.toString() : ""
    );

    const cabinet = DESK_OPTIONS[CABINET].find(
      (item: any) => item.value === checkDesk
    );

    const desk = DESK_OPTIONS[DESK].find(
      (item: any) => item.value === checkDesk
    );

    const isSpecialBed = feature[0]?.product_props?.find(
      (p: any) => p.code === "LOAI"
    )?.is_special_bed;

    const deskObj = checkProductHaveType(feature)
      ? {
          label:
            slug === "giuong" ||
            feature[0].slug?.toLowerCase().includes("giuong")
              ? isSpecialBed
                ? cabinet?.label2
                : cabinet?.label
              : desk?.label,

          value: checkDesk,
        }
      : null;

    const coverObj =
      feature && feature.length && feature[0].value
        ? checkProductHaveCover(feature[0].value, checkRossyLuxeValue) ||
          checkNewProductFeatureHaveCover(feature[0])
          ? {
              label:
                checkRossyLuxeValue ||
                checkNewProductFeatureHaveCover(feature[0])
                  ? PRODUCT_PROPS_SOFA_ROSSY_LUXE_COVER.find(
                      (cover: any) => cover.value === typeCover
                    )?.label
                  : PRODUCT_PROPS_COVER.find(
                      (cover: any) => cover.value === typeCover
                    )?.label,

              value: typeCover,
            }
          : null
        : null;

    const foamObj = currentFeature.is_have_foam
      ? {
          label: product.specs.find(
            (spec: any) => spec.kde_pro_spec_id === foam
          )?.extra_name,
          value: foam,
        }
      : null;

    const featureObj = {
      label: currentFeature.label,
      value: currentFeature.value,
    };

    return {
      foam: foamObj,
      feature: featureObj,
      desk: deskObj,
      cover: coverObj,
      pattern: null,
    };
  };

  const handleAddToCompare = (gifts: any) => {
    const _data = {
      img: currentFeature?.img?.path,
      name: currentFeature?.name,
      price: currentFeature?.price,
      price_promotion: currentFeature.price_promotion,
      properties: getPropertiesCompare(),
      gifts: gifts,
      dataAddToCart: getDataAddToCart(),
    };

    dispatch(addCompareProduct(_data));
  };

  const handleRemoveFromCompare = () => {
    const properties = getPropertiesCompare();

    const index = compareProducts.findIndex((item: any) => {
      let check = false;

      if (
        properties.feature?.value === item.properties?.feature?.value &&
        properties.desk?.value === item.properties?.desk?.value &&
        properties.foam?.value === item.properties?.foam?.value &&
        properties.cover?.value === item.properties?.cover?.value
      ) {
        check = true;
      }

      return check;
    });

    dispatch(removeCompareProduct(index));
  };

  const getEntityForSlug = () => {
    if (currentFeature.cat_id_v2) {
      return currentFeature;
    } else {
      return product;
    }
  };

  const getProductItemProps = () => ({
    productId: currentFeature.cat_id_v2 || product.cat_id,
    productPath: getSlugByLanguage(getEntityForSlug(), i18n.language),
    productFoam: currentFeature.is_have_foam ? foam : null,
    img: getImage(),
    name: getName(),
    featureCode: currentFeature.value,
    price: currentFeature.price,
    price_promotion: currentFeature.price_promotion,
    discount_percent: currentFeature.discount_percent,
    price_installment: currentFeature.price_installment,
    info_promotion: currentFeature.info_promotion,
    quantity: quantity,
    category_name: product.category_name,
    features: {
      options: listFeatures,
      currentValue: currentFeature,
      handleOnChange: handleOnChange,
      is_need_dropdown_features: isNeedDropdownFeatures,
      is_label_dropdown: product.is_label_dropdown,
      is_special_category: product.is_special_category,
      is_hide_thick_dropdown: product.is_hide_thick_dropdown,
      is_normal_dropdown: product.is_normal_dropdown,
    },
    covers: {
      features: feature,
      productId:
        feature && feature.length ? feature[0].cat_id_v2.toString() : "",
      typeCover: typeCover,
      handleOnChangeCover: handleOnChangeCover,
      checkDesk: checkDesk,
      minKdeProId: minKdeProId,
    },
    foams: currentFeature.is_have_foam
      ? {
          currentValue: foam,
          options: product.specs,
          handleChangeFoam: handleChangeFoam,
        }
      : null,
    desk: checkProductHaveType(feature)
      ? {
          code:
            slug === "giuong" ||
            feature[0].slug?.toLowerCase().includes("giuong")
              ? CABINET
              : DESK,
          handleChangeType: handleChangeType,
          currentValue: checkDesk,
        }
      : null,
    isHaveMoreGift: checkGrandOpeningPromotion(
      isCheckGrandOpeningPromotion,
      currentFeature.price,
      currentFeature.category_id === ID_CATEGORY_MATTRESS
        ? currentFeature.category_id
        : currentFeature.cat_id_v2
    ),
    isNeedCompare: true,
    isInCompareList: checkInCompareList(
      getPropertiesCompare(),
      compareProducts
    ),
    isNeedContact: product.is_need_contact,
    pattern_name: hasPillowSpec ? currentFeature.pillowSpec.name : null,
    productSpecCode: hasPillowSpec
      ? currentFeature.pillowSpec.kde_pro_spec_id
      : null,
    addToCart: handleAddToCart,
    decreaseQuantity: decreaseQuantity,
    increaseQuantity: increaseQuantity,
    resetQuantity: resetQuantity,
    addToCompare: (gifts: any) => handleAddToCompare(gifts),
    removeFromCompare: handleRemoveFromCompare,
    renderWishButton: () => <WishButton {...props} feature={currentFeature} />,
  });

  return <ProductItemComponent {...getProductItemProps()} />;
};

export default FilterProductItem;
